import { Chip, type SxProps, type Theme } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

const baseStyle = {
  height: '24px',
  borderRadius: '12px',
  boxShadow: 'var(--shadow-xs)',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  '& .MuiChip-label': {
    padding: '0 4px 0 10px'
  },
  '& .MuiChip-deleteIcon': {
    fontSize: '16px',
    margin: '0 10px 0 0'
  }
} satisfies SxProps<Theme>

const validStyle = {
  ...baseStyle,
  backgroundColor: 'var(--blue-500)',
  color: 'var(--white)',
  '& .MuiChip-deleteIcon': {
    ...baseStyle['& .MuiChip-deleteIcon'],
    color: 'var(--white)',
    '&:hover': { color: 'var(--blue-50)' }
  }
} satisfies SxProps<Theme>

const invalidStyle = {
  ...baseStyle,
  backgroundColor: 'var(--red-50)',
  color: 'var(--red-900)',
  border: '1px solid var(--red-700)',
  '& .MuiChip-deleteIcon': {
    ...baseStyle['& .MuiChip-deleteIcon'],
    color: 'var(--red-900)',
    '&:hover': { color: 'var(--red-700)' }
  }
} satisfies SxProps<Theme>

interface SelectionChipProps {
  label: string
  onDelete?: () => void
  invalid?: boolean
  dataTestId?: string
}

export const SelectionChip = ({ label, onDelete, invalid = false, dataTestId }: SelectionChipProps): JSX.Element => (
  <Chip
    label={label}
    size='small'
    onDelete={onDelete}
    deleteIcon={<CloseRoundedIcon />}
    data-testid={dataTestId}
    sx={invalid ? invalidStyle : validStyle}
  />
)
